(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-small-module"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePolicyMini = (root) => {
      if (!root || root.dataset.policyReady === 'true') return;

      const track = root.querySelector('[data-policy-track]');
      const slides = Array.from(root.querySelectorAll('[data-policy-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-policy-dot]'));
      if (!track || slides.length === 0) return;

      root.dataset.policyReady = 'true';
      let frame;

      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const currentIndex = () => {
        const width = track.clientWidth;
        if (!width) return 0;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          setActive(index);
        });
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => setActive(currentIndex()));
      }, { passive: true });

      const initial = Math.max(0, Math.min(slides.length - 1, Number(root.dataset.initialSlide) || 0));
      setActive(initial);

      const positionInitial = () => {
        if (window.matchMedia('(max-width: 767px)').matches && initial > 0) {
          track.scrollLeft = slides[initial].offsetLeft - track.offsetLeft;
        }
      };

      window.requestAnimationFrame(positionInitial);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-policy-mini]').forEach(initializePolicyMini);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
